// Helps with session ID cookie management for player identification

import { v4 as uuidv4 } from 'uuid';

const SESSION_COOKIE_NAME = 'sessionId';
const SESSION_EXPIRY_DAYS = 3;
const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

// Cookie attributes for security
const COOKIE_ATTRIBUTES = [
  'path=/',
  'SameSite=Lax',
  import.meta.env.PROD ? 'Secure' : '',
]
  .filter(Boolean)
  .join('; ');

/**
 * Gets the current session ID from cookie if it exists
 */
export function getSessionId(): string | null {
  const match = document.cookie.match(
    new RegExp(`(^| )${SESSION_COOKIE_NAME}=([^;]+)`)
  );
  return match ? decodeURIComponent(match[2]) : null;
}

/**
 * Creates a new session ID and sets it as a cookie
 */
export function createSessionId(): string {
  const sessionId = uuidv4();
  const expires = new Date(
    Date.now() + SESSION_EXPIRY_DAYS * MILLISECONDS_PER_DAY
  ).toUTCString();
  document.cookie = `${SESSION_COOKIE_NAME}=${sessionId}; expires=${expires}; ${COOKIE_ATTRIBUTES}`;
  return sessionId;
}

/**
 * Gets existing session ID or creates a new one
 */
export function getOrCreateSessionId(): string {
  return getSessionId() || createSessionId();
}

/**
 * Clears the session ID cookie
 */
export function clearSessionId(): void {
  document.cookie = `${SESSION_COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; ${COOKIE_ATTRIBUTES}`;
}
